import styled from "styled-components";

export const StyledTableContainer = styled.div`
  overflow-x: auto;

  transform: rotateX(180deg);
  padding-bottom: 10px;

  .c-table {
    transform: rotateX(180deg);
    padding-bottom: 10px;
  }

  ::-webkit-scrollbar {
    height: 6px;
  }
`;
